export default __webpack_public_path__ + "static/media/H4004.aec22a0b.mp3";